export default "__VITE_ASSET__Cr24aQGr__"